if (!customElements.get('motivational-quotes')) {
  class MotivationalQuotes extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.mq__slider');
      this.isPaused = false;

      this.addEventListener('mouseenter', this.pauseSlider.bind(this));
      this.addEventListener('mouseleave', this.resumeSlider.bind(this));

      this.init();
    }

    init() {
      if (!this.slider) return;

      const slides = this.slider.querySelectorAll('.mq__slide');
      if (slides.length < 2) return;

      slides[0].classList.add('is-visible');

      const delay = parseInt(this.dataset.slideDelay, 10) || 5000;

      const nextSlide = () => {
        if (!this.isPaused && theme.elementUtil.isInViewport(this)) {
          const currSlide = this.slider.querySelector('.mq__slide.is-visible');
          const currSlideIndex = Array.from(currSlide.parentNode.children).indexOf(currSlide);
          const nextSlideIndex = currSlideIndex + 1 < slides.length ? currSlideIndex + 1 : 0;

          currSlide.classList.remove('is-visible');
          currSlide.classList.add('is-leaving');
          slides[nextSlideIndex].classList.add('is-visible');

          setTimeout(() => {
            currSlide.classList.remove('is-leaving');
          }, 500);
        }

        setTimeout(nextSlide, delay);
      };

      setTimeout(nextSlide, delay);
    }

    pauseSlider() {
      this.isPaused = true;
    }

    resumeSlider() {
      this.isPaused = false;
    }
  }

  customElements.define('motivational-quotes', MotivationalQuotes);
}
